import { Expose, Type } from 'class-transformer';
import { OrganizationType } from '../../../enums/clients';
import { SampleRetentionAnnex } from '../../../enums/sample-retention-annex.enum';
import { ContactWithRoleResponseDto } from '../contact/contact-with-role.response.dto';

export class OrganizationResponseDto {
    @Expose()
    id: string;

    @Expose()
    organizationName: string;

    @Expose()
    address: string;

    @Expose()
    organizationType: OrganizationType;

    @Expose()
    hasDel: boolean;

    @Expose()
    delNumber: string;

    @Expose()
    hasNhpSiteLicence: boolean;

    @Expose()
    nhpSiteLicence: string;

    @Expose()
    hasMdel: boolean;

    @Expose()
    mdelNumber: string;

    @Expose()
    hasDealersLicence: boolean;

    @Expose()
    dealersLicence: string;

    @Expose()
    isLicenseAvailable: boolean;

    @Expose()
    qualityAgreement?: string;

    @Expose()
    isWholesaleLicenseConfirmed?: boolean;

    @Expose()
    wholesaleLicenseMethod?: string;

    @Expose()
    testingServiceApi: boolean;

    @Expose()
    testingServiceId: boolean;

    @Expose()
    testingServiceConfirmatory: boolean;

    @Expose()
    testingServiceStability: boolean;

    @Expose()
    specialLabNotes: string;

    @Expose()
    lotReleaseBlockedUntilConfirmatory: boolean;

    @Expose()
    lotReleaseComments: string;

    @Expose()
    notes: string;

    @Expose()
    sampleRetentionAnnex?: SampleRetentionAnnex;

    @Expose()
    sampleRetentionComments?: string;

    @Expose()
    additionalLicensableActivities?: string;

    @Expose()
    @Type(() => ContactWithRoleResponseDto)
    contacts?: ContactWithRoleResponseDto[];

    @Expose()
    clientRecordId: string;

    @Expose()
    @Type(() => Date)
    createdAt: Date;

    @Expose()
    @Type(() => Date)
    updatedAt: Date;
}
